import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {StaticImage} from '../../../design-system/atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../../design-system/atoms/StaticImage/StaticImageType.enum';
import {ErrorArea} from '../../../design-system/organisms/ErrorArea/ErrorArea';
import {PC_HEADER_HEIGHT} from '../../../design-system/organisms/PcHeader/constants';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';

export function Maintenance({isMobile}: {isMobile: boolean}) {
  return (
    <>
      <div
        className="flex items-center w-full"
        style={
          isMobile
            ? {
                height: `${MOBILE_HEADER_HEIGHT_PX}px`,
                paddingLeft: 15,
                paddingTop: 19,
              }
            : {height: `${PC_HEADER_HEIGHT}px`, paddingLeft: 30}
        }
      >
        <StaticImage imageType={StaticImageType.LogoBiTextL} />
      </div>
      <ErrorArea
        isMobile={isMobile}
        isDesignFree={true}
        className={twMerge(isMobile && 'px-15pxr')}
      >
        <ErrorArea.Image
          type={StaticImageType.ExceptionNoticeLStatic}
        ></ErrorArea.Image>
        <ErrorArea.Title className="font-large3-bold mt-32pxr text-theme-solid-100">
          {isMobile
            ? t('service_maintenance_popup')
            : t('service_under_maintenance')}
        </ErrorArea.Title>
        <ErrorArea.MainText className="font-small1 mt-16pxr text-theme-solid-60">
          {isMobile
            ? t('service_maintenance_description_mw')
            : t('service_maintenance_description')}
        </ErrorArea.MainText>
      </ErrorArea>
    </>
  );
}
